import { EnterpriseContactForm } from "@/components/LandingPage/EnterpriseContactForm";
import { Footer } from "@/components/LandingPage/Footer";
import { GetStarted } from "@/components/LandingPage/GetStarted";
import { TestimonialsSection } from "@/components/LandingPage/TestimonialsSection";
import { Box } from "@chakra-ui/react";
import Head from "next/head";

export default function Page() {
  return (
    <>
      <Head>
        <title>Enterprise Contact</title>
      </Head>
      <Box>
        <EnterpriseContactForm />
        <TestimonialsSection />
        <GetStarted />
        <Footer />
      </Box>
    </>
  );
}
